"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCalendarPeriodFail = exports.setCalendarPeriodSuccess = exports.setCalendarPeriod = exports.setMeetingPreferencesFail = exports.setMeetingPreferencesSuccess = exports.setMeetingsPreferences = exports.unsubscribeFail = exports.unsubscribeSuccess = exports.unsubscribe = exports.setCountryFail = exports.setCountrySuccess = exports.setCountry = exports.setCurrencyFail = exports.setCurrencySuccess = exports.setCurrency = exports.resetPasswordFail = exports.resetPasswordSuccess = exports.resetPassword = exports.setPasswordFail = exports.setPasswordSuccess = exports.setPassword = exports.getSettingsFail = exports.getSettingsSuccess = exports.getSettings = void 0;

var _reduxAct = require("redux-act");

var _ramda = require("ramda");

var PREFIX = 'COMMON/PROFILE_SETTINGS/PERSONAL';
var getSettings = (0, _reduxAct.createAction)("".concat(PREFIX, "/GET_SETTINGS_REQUEST"));
exports.getSettings = getSettings;
var getSettingsSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/GET_SETTINGS_SUCCESS"));
exports.getSettingsSuccess = getSettingsSuccess;
var getSettingsFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/GET_SETTINGS_FAIL"));
exports.getSettingsFail = getSettingsFail;
var setPassword = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_PASSWORD_REQUEST"), function () {
  return undefined;
}, _ramda.identity);
exports.setPassword = setPassword;
var setPasswordSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_PASSWORD_SUCCESS"));
exports.setPasswordSuccess = setPasswordSuccess;
var setPasswordFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_PASSWORD_FAIL"));
exports.setPasswordFail = setPasswordFail;
var resetPassword = (0, _reduxAct.createAction)("".concat(PREFIX, "/RESET_PASSWORD_REQUEST"));
exports.resetPassword = resetPassword;
var resetPasswordSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/RESET_PASSWORD_SUCCESS"));
exports.resetPasswordSuccess = resetPasswordSuccess;
var resetPasswordFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/RESET_PASSWORD_FAIL"));
exports.resetPasswordFail = resetPasswordFail;
var setCurrency = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_CURRENCY_REQUEST"));
exports.setCurrency = setCurrency;
var setCurrencySuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_CURRENCY_SUCCESS"));
exports.setCurrencySuccess = setCurrencySuccess;
var setCurrencyFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_CURRENCY_FAIL"));
exports.setCurrencyFail = setCurrencyFail;
var setCountry = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_COUNTRY_REQUEST"));
exports.setCountry = setCountry;
var setCountrySuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_COUNTRY_SUCCESS"));
exports.setCountrySuccess = setCountrySuccess;
var setCountryFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_COUNTRY_FAIL"));
exports.setCountryFail = setCountryFail;
var unsubscribe = (0, _reduxAct.createAction)("".concat(PREFIX, "/UNSUBSCRIBE_REQUEST"));
exports.unsubscribe = unsubscribe;
var unsubscribeSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/UNSUBSCRIBE_SUCCESS"));
exports.unsubscribeSuccess = unsubscribeSuccess;
var unsubscribeFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/UNSUBSCRIBE_FAIL"));
exports.unsubscribeFail = unsubscribeFail;
var setMeetingsPreferences = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_MEETING_PREFERENCES_REQUEST"));
exports.setMeetingsPreferences = setMeetingsPreferences;
var setMeetingPreferencesSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_MEETING_PREFERENCES_SUCCESS"));
exports.setMeetingPreferencesSuccess = setMeetingPreferencesSuccess;
var setMeetingPreferencesFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_MEETING_PREFERENCES_FAIL"));
exports.setMeetingPreferencesFail = setMeetingPreferencesFail;
var setCalendarPeriod = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_CALENDAR_PERIOD_REQUEST"));
exports.setCalendarPeriod = setCalendarPeriod;
var setCalendarPeriodSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_CALENDAR_PERIOD_SUCCESS"));
exports.setCalendarPeriodSuccess = setCalendarPeriodSuccess;
var setCalendarPeriodFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_CALENDAR_PERIOD_FAIL"));
exports.setCalendarPeriodFail = setCalendarPeriodFail;